import { projectStageKpiResponseSchema } from '@si/types';
import { get, objectToQueryParams } from '@si/utils';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { queryKeys } from './queryKeys';

interface Params {
  from: Date;
  to: Date;
  enabled?: boolean;
}

export function useProjectStageKpi({ from, to, enabled = true }: Params) {
  const url = `/admin/project-stage-kpi${objectToQueryParams({ from, to })}`;

  const { data, error, isLoading, isFetching } = useQuery({
    queryKey: queryKeys.getProjectStageKpi(from, to),
    queryFn: () => get({ url, schema: projectStageKpiResponseSchema }),
    enabled,
    placeholderData: keepPreviousData,
  });

  return {
    snapshots: data?.snapshots ?? [],
    error,
    isLoading,
    isFetching,
  };
}
